<template>
  <div class="main">
    <p>
    <h1 class="fs-18 m-t-60 m-b-10" style="margin-left:0px;font-family:&quot;font-weight:500;color:#333333;vertical-align:baseline;background-color:#FAFAFA;font-size:18px !important;">
      服务条款
    </h1>
    <p style="font-size:14px;vertical-align:baseline;font-family:Arial, Helvetica, sans-serif, 宋体;background-color:#FAFAFA;color:#696969 !important;">
      生意专家团队由一群充满激情与智慧的年轻人组成。我们从创立之初就深知，信息技术将推动巨大的商业变革，从而给客户和我们带来无限商机。我们希望通过信息技术和服务创新，为我们的客户带来源源不断的生意。
    </p>
    <div class="m-b-90" style="margin-left:0px;padding:0px;border:0px;font-size:14px;vertical-align:baseline;color:#333333;font-family:Arial, Helvetica, sans-serif, 宋体;background-color:#FAFAFA;">
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        感谢您对 生意专家的关注！
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        我们邀请您访问我公司网站，使用我公司提供的服务（定义见下文），但请注意，对您提出的邀请取决于您审阅并同意特定条款和条件。该等条款和条件在本文以及某些其他政策、指南及可能就特定的服务提供在我公司网站上不时向您提出的其他条款或条件（所有条款和条件均可能不时更新，以下统称为我公司“服务条款”）中列明。我公司并不要求您接受本服务条款合同，但若您拒绝接受我公司服务条款，则您无权获取或使用我们所提供的服务。若您确实访问我公司网站并使用我们所提供的服务，您使用服务即应被视为接受服务条款，并成为与上海圆贝信息科技有限公司（又称“我公司”或“我们”）订立具有法律约束力的合同之一方当事人。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        同时，您也可能被要求或选择与我公司另行订立书面协议，或点击“接受”或“同意”钮以成为与我公司订立的另一份合同（“另行订立之协议”）的一方当事人，且本服务条款不应被视为取代另行订立之协议的具体合同条款。若另行订立协议的条款与本服务条款存在任何不一致之处，则就该等另行订立协议的事宜，另行订立协议的条款应优先于服务条款中与之相冲突的条款。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您可能希望保存本服务条款的副本备查。在任何情况下，请务必定期查看本服务条款是否有任何更新或其他变更，该等更新或其他变更在我公司予以发布时即对您具有法律约束力，无论我公司是否就该等变更向您发出任何其他通知。届时适用的服务条款将在<a href="http://www.i200.cn/legal/www.i200.cn">www.i200.cn</a>上发布，且我们将于服务条款的顶端标明每次更新的生效日期。您在任何更新后继续使用服务，将视为您同意受新的服务条款的约束并对其作出同意。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        服务内容
      </h1>
      <p class="position:relative" style="vertical-align:baseline;color:#696969 !important;">
        生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>服务包括由 上海圆贝信息科技有限公司托管或提供的、您可能在现在已知或此后开发的多个计算机及网络平台上，为获取、组织、搜索、存储、同步、识别及传输任何数量的键入或修改而使用之产品、计算机程序、窗口部件、服务及网站（合称“服务”）。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        服务使用
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        依照本服务条款中的条款和条件，我公司向您授予使用服务的有限、非独占许可，前提是：（1）您已达到订立有约束力的合同的法定年龄，及（2）中华人民共和国法律未禁止您接受服务。为获取和（或）使用服务，您可能需要在注册过程继续使用服务的过程中提供当前准确的识别、联系及其他信息，且您有责任保持该等信息的准确和完整。您还会获得一个帐户，以获取或使用服务。您有责任对您的帐户信息保密，并因此对在您的帐户下进行的全部活动（包括您已向其提供您的帐户信息的其他人所进行的活动）负完全责任。您同意，对于任何擅自使用您的帐户信息及帐户的行为或任何其他的破坏安全的行为，您将立即告知我公司。对于因您未能向我公司提供准确信息或保持您的帐户信息安全而引起的任何损失或损害，我公司概不负责。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        对于为获取服务而需取得的设备及电信服务，以及与之相关的全部费用（如计算设备及互联网服务提供商及国际漫游通话费），由您自行负责。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        现在的个体店铺无论是在使用现有管理软件的易用性上，还是在购买软件的资金和后续软件服务方面都存在许多问题。个体店铺的经营效率亟待提升，他们需要一个量身定做的经营助手和管理方案，生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>即为此而诞生！ 我们帮助小型服务业企业和个体经营者科学量化管理、规范经营、提升服务质量，从而增强经营效率，并将管理软件的成本从几千元降低到10元钱。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        用户行为
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您确认并同意，所有信息、数据、文本、图象其他材料（“内容”），均由创设该等内容并将该等内容引入服务之人独立承担责任。我公司保留对经由服务可获得的任何内容进行预筛选、拒绝、审阅、隔离的权利，但对此不承担任何义务。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您同意对以下事项负责：您自身的行为以及在您的帐户下的全部行为，以及任何人使用您的帐户信息与服务存储、传播或展示的全部内容，以及由此产生的任何后果。您同意仅为合法、适当且符合本服务条款及任何另行订立之协议及所有适用的法律法规的目的而使用服务。在不限制前述条款的前提下，您应被视为向我公司陈述和保证，您拥有不受限制的合法权利及权限，允许您向我公司提交与使用服务相关的内容，且该等向我公司的内容提交及您在此就我公司提供和运营服务而授予我公司的权利，不侵犯任何人或第三方的权利。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        通过“联系客服”界面、论坛或其他方式向我公司提交的任何想法、建议、文件和（或）建议书（合称“供稿”），您确认并同意：（1）您的供稿不包含机密或专有信息；（2）对于供稿，我公司不负有任何明示或暗示的保密义务；（3）我公司有权为任何目的，以任何方式，在全球范围内的任何媒体中，使用或披露（或选择不使用或不披露）该等供稿；（4）我公司可能拥有已在审议或处于开发过程中的与供稿相似的内容；（5）您的供稿自动归我公司所有，且我公司不对您负有任何责任；及（6）您在任何情况下均无权自我公司得到任何类型的报账、赔偿或报销。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        您进一步同意不做出以下行为：
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>提供终身免费的版本。免费版可以满足店铺日常管理的所有需要，所以您可以放心的一直用下去。 为满足更高级的用户在营销管理方面的需求，生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>还提供相应的收费版本和各类提升店铺销售的增值服务，您可以根据生意的发展按需定制。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        为不合法的目的或为推广危险活动而使用我公司的产品或服务；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        假扮任何人或实体（包括但不限于我公司的员工），或假称或不实陈述您与我公司或任何其他人或实体的关联；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        传播您在任何法律或合同关系或信托关系项下无权传播的任何内容（如作为劳动关系的一部分或在保密协议项下知悉或披露的内幕信息、专有及保密信息）；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        上传、发布或传播任何未经请求或未经授权的广告、推广材料、“垃圾短信”、“兜售信息”、“连锁信”、“金字塔骗局”或任何其他形式的招揽；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        干涉或妨碍服务或与服务有关的服务器或网络，或不遵守任何与服务有关或适用于服务的网络要求、程序、政策或规定；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        违反中国宪法的基本原则，或违反任何适用的中国法律或任何具有法律效力的规定；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        推广或提供有关非法活动的指导性信息，推广针对政府、法律实体、团体或个人的物理性伤害或损害，或推广虐待动物的行为，包括但不限于就如何装配爆炸装置或其他武器或纵火装置提供指导；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        允许他人以违反本服务条款的方式使用服务；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        利用手段妨碍服务范围内任何广告的充分和完全展示，包括但不限于：有效阻止或实质上损害服务范围内的广告展示的风格变更、定制或覆盖；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        为非预期、商业或不合法的目的，向其他用户索取密码或个人辨识信息；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        超出您注册的服务范围，例如：获取及使用您无权使用的特性，或在您获知他人密码的情况下，删除、添加或变更另一人之录入项目或其他内容；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        通过我公司所提供的界面以外的任何方式（除非在另行订立之协议中明确允许您如此行事）获取（或试图获取）任何服务，或通过任何自动化的途径（包括使
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        用脚本、网络蜘蛛等）获取（或试图获取）任何服务，或以经合理判断可能对运营服务的系统或他人获取或使用服务造成损害的方式使用服务；及/或；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        为任何商业目的，复制、复印、出售、买卖、转售或利用任一部分服务，或对服务的使用或获取行为（除非在另行订立之协议中明确允许您如此行事）；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        采取任何可能违反我公司的相关商标指引及使用要求的行动；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        及就公共笔记本，您进一步同意，不上传或传播以下内容：
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        含有裸露、性暴露内容或被我公司视为暴露的内容；或
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        含威胁性、辱骂性、骚扰性、诽谤性、损害名誉、侵犯性、憎恨性或 从种族、民族或其他角度令人不快的内容。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        危害国家安全、泄露国家机密、颠覆国家权力或破坏国家统一的内容；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        鼓励赌博、暴力、谋杀、恐吓或煽动犯罪行为的内容；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        散布谣言、扰乱社会秩序或破坏社会稳定的内容；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        煽动民族仇恨或种族歧视或破坏民族内部团结的内容；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        或破坏中国的民族政策或宣扬异端邪说或封建迷信的内容。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        如果您遇到任何上述被禁止使用的情况，您可拨打客服电话400－168－3399，按人工提示将相关信息提交至我公司。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        隐私政策
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        我公司的隐私政策刊登在<a href="http://www.i200.cn/legal/www.i200.cn">www.i200.cn</a>。通过使用服务，您确认、接受并同意隐私政策的全部规定，包括但不限于依照该等隐私政策使用您的账户信息及您的内容。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        我公司的权利
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您确认并同意，我公司（及向我公司授权的任何许可方）对于服务拥有全部合法权利、所有权及利益，包括但不限于所有构成我公司服务器上托管或由您或第三方使用的服务之一部分。您进一步确认并同意，对于服务的权利，包括所有知识产权，除受本服务条款及任何另行订立之协议保护外，亦受一部或多部版权、商标、专利、商业秘密及其他法律、法规及条约的保护。除在本服务条款中向您明确授予的有限的许可权利（及在另行订立之协议中向您明确授予的任何权利）外，我公司及其供应商拥有并应保留全部权利、所有权及利益，包括但不限于对于服务及所有在服务中使用的软件（及其所有副本，以及与服务一道向您交付或提供的相关材料）的知识产权。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        为向您提供服务，我公司必须获得关于您提交内容的特定许可和其他权利（以便我公司对您的内容进行处理、维护、存储、技术复制、备份及发送）。据此，一旦使用服务并上传内容，即视为您许可。您亦同意，我公司有权自行决定不接受、存储、发送或传播任何内容。您同意，该等权利和许可为免收使用费、不可撤销、并在全球范围内有效，并且包含以下权利：我公司有权仅为提供该等服务之目的，将该等内容提供予并将该等权利转移至因提供服务而与我公司建立合同关系的其他方，且有权允许第三方获取您所提供的内容（在我公司认定该等获取对于履行其法定义务实属必要的前提下）。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        除在本服务条款中授予的有限许可及其他权利外，您保留您在提交内容前对内容拥有的全部权利；除非您选择允许他人查看或获取您向服务提交的内容，否则任何其他人均不应在未获得您同意的情况下查阅您的内容。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        您的权利
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        正如上文所述，您保留您在服务之上或通过服务提交、发布或展示的内容中已持有的权利。除您在本服务条款中授予的有限许可及其他权利外，我公司确认并同意，不取得您（或您的许可方）在本服务条款项下授予的、对您在服务之上或通过服务提交、发布、存储、传播或展示的任何内容的任何权利、所有权或利益（无论该等权利是否已注册或在世界任何地方存在）。您同意，您对保护和行使该等权利负全责，我公司无义务代您负责。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        作为我公司向您提供的服务的一部分，我公司特此授予您私人、全球范围、免收使用费、不可转让且非独占的许可，允许您仅为使用和享受本服务条款允许的服务所产生的利益之目的使用我公司向您提供的软件，直至您享有的权利依照本服务条款而终止。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        服务之组成部分
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        我公司保留经自行判断对下列内容加以限制的权利：您可以获取的存储空间性质或大小、任何索引或库信息的性质或大小、您所提交的内容和其他数据的性质，并有权经通知或不经通知进行其他限制。您确认，我公司采取的多种行动均可能在一定期间内或永久性地损害或阻止您在特定时间和（或）以相同方式访问您所提交的内容或使用服务，并同意我公司不因任何该等行动或结果（包括但不限于删除内容或未能向您提供内容）承担责任或负有义务。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        我公司有权随时聘请特定关联公司或其他第三方向您提供全部或部分服务，且您特此确认并同意接受该等第三方参与服务。您理解，我公司在采取向用户提供服务所需的技术步骤时，可能对您提交的内容作出必要更改，以便符合并调整内容使其符合连接互联网、设备、服务或媒体的技术要求。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        我公司可能随时将由第三方提供的计算机软件（包括但不限于已获得各自许可方和（或）著作权人许可、按该等许可方和（或）著作权人规定的条款使用的本第三方软件）纳入服务范围。我公司明示拒绝就该等第三方软件向您提供任何保证或其他担保。。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        免责声明
      </h1>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        您明示理解并同意：
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        将自行承担使用服务之风险。服务“依原样”且在“可获取”的基础上提供。在法律允许的最大范围内，我公司明示拒绝任何类型的明示或默示保证和条件，包括但不限于关于适销性、适用于某一特定目的和不侵权的默示保证和条件。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        我公司不保证：（i）服务将满足您的全部要求；（ii）服务将免于中断、及时或无误；或（iii）您所认为的软件中的错误将得到改正。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您从我公司获得的、或经由或源自服务获得的口头或书面建议或信息，均不设立未在本服务条款中明示声明的任何保证。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        责任限制
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您明示理解并同意，我公司、其子公司、关联公司和许可方，以及我公司及上述各方之主管人员、员工、代理人，均不对因以下原因造成的任何直接、间接、附带、特殊、后续或惩戒性损害向您承担责任，包括但不限于利润亏损、商誉、实用性、数据、保证金或其他无形损失（即便我公司已被告知该等损害的可能性）：
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        使用或无法使用服务；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        因通过服务或源自服务的任何商品、数据、信息，或购买或获取的任何服务，或收到的信息或达成的交易，采购替代商品和服务的成本；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您未能对任何密码保密，或未能保护您账户信息的访问权利；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        使用服务的任何第三方的作为或不作为；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        任何广告内容或您购买或使用任何广告产品或服务；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您的账户根据本服务条款的规定中止或终止；
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        因政府或其他有权部门采取的行动或发布的我公司理解我们必须遵守的命令，使您的账户受到影响；或
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        任何与服务相关的其他事项。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        排除和限制
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        本协议任何内容均不以排除或限制任何不得合法排除或限制的条件、保证、权利或义务为目的。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        通知
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您同意，我公司可依自行判断，经电子邮件、短信或在与受影响服务相关的网站张贴通告向您发出通知，且我公司可以信赖您提供的联系信息准确、完整且当前有效。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        一般条款
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        除非您已签订另行订立之协议，否则本服务条款构成您与我公司之间的完整协议，适用于您对服务的使用。（不时生效的）本服务条款取代您与我公司之间为使用服务之目的而签署的任何先前的协议或本服务条款的较早版本。如果您通过访问或使用服务，利用或获取来自第三方的任何产品或服务，您还可能受限于该等第三方的相关条款和条件，且本服务条款不影响您与该等第三方的法律关系。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您确认并同意，我公司的各关联公司均为本服务条款的第三方受益人，且该等其他公司有权直接强制执行并依赖本服务条款中授予其利益（或向其提供以其为受益人的权利）的任何规定。除此之外，任何其他人或公司均不得作为本服务条款的第三方受益人。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        本服务条款以及您与我公司的关系受中华人民共和国法律管辖。您与我公司同意，就本服务条款的解释、执行等发生的争议，接受我公司所在地有管辖权的人民法院的排他管辖。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        我公司未能或延迟行使或强制执行本服务条款项下的任何权利或条款、或适用法律项下的权利，不构成对任何该等条款或权利的弃权。如果具备管辖权的法院判定本服务条款之任何规定无效，双方仍然同意法院应尽力实现双方在该规定中反映的意图，且协议之其他条款应保持完全效力。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        您同意，尽管有任何相反法规或法律，因使用服务引起的或与之相关的或在本服务条款项下的任何主张或诉讼事由，必须在该等主张或诉讼事由出现后一（1）年内提出，否则，您同意永远不提出该等主张。
      </p>
      <p style="vertical-align:baseline;color:#696969 !important;">
        本服务条款之章节标题仅为行文方便而设，不具有法律或合同效力。
      </p>
      <h1 class="fs-18 m-t-30 m-b-15" style="margin-left:0px;font-size:18px !important;font-family:&quot;font-weight:500;color:inherit;vertical-align:baseline;">
        可选服务
      </h1>
      <p style="vertical-align:baseline;color:#696969 !important;">
        敬请注意， 生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>提供之服务不同于上海圆贝信息科技有限公司提供之服务。 生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>之服务从中国上海提供，在中国境内使用可实现最优效果。您对 生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>的使用受本协议条款管辖，且在本协议项下，您并未获得使用上海圆贝信息科技有限公司服务或软件的任何权利。此外，如果您选择同时使用 生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>和上海圆贝信息科技有限公司提供的服务，您确认，您上传至各自服务的内容将作为完全独立且不同的内容，由 生意专家<span style="font-size:12px;line-height:0;vertical-align:baseline;">™&nbsp;</span>和上海圆贝信息科技有限公司分别处理，两种服务不以任何方式整合，且分别受针对各服务的使用条款和隐私政策管辖。
      </p>
    </div>
    </p>
    <p>
      <br />
    </p>
  </div>
</template>
<script>
  export default {
    name: 'TheProvisionPage',
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/base/_mixin";
  .main {
    overflow: hidden;
    padding: 0 px2rem(25px) 0 px2rem(25px);
    background: #fafafa;
  }
  .m-t-60 {
    margin-top: px2rem(60px);
  }
  .m-b-10 {
    margin-bottom: px2rem(10px);
  }
  .m-t-30 {
    margin-top: px2rem(30px);
  }
  .m-b-15 {
    margin-bottom: px2rem(15px);
  }
  .m-b-90 {
    margin-bottom: px2rem(90px);
  }
  p {
    color: #696969!important;
  }
</style>



// WEBPACK FOOTER //
// TheProvisionPage.vue?52cf7004